import React, { useState } from 'react';
import { Grid, Drawer, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { CalendarToday } from '@material-ui/icons';
import EventTourDrawer from './Drawer';
import CustomButtonIcon from '../Common/ButtonIcon';

const EventTour = props => {
  const { eventMeta } = props;

  const [eventOpen, setEventOpen] = useState(false);

  const useStyles = makeStyles({
    drawerPaper: {
      top: '70px',
      width: '250px',
      height: '-webkit-fill-available',
      overflowX: 'hidden',
    },
  });
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item>
        <CustomButtonIcon
          tooltip
          tooltipTitle="Click to see more events"
          size="large"
          onClick={() => setEventOpen(true)}
          width="40px"
          height="40px"
        >
          <CalendarToday style={{ fontSize: '23px' }} />
        </CustomButtonIcon>
      </Grid>
      <Drawer
        anchor="right"
        open={eventOpen}
        onClose={() => setEventOpen(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
        variant="persistent"
      >
        <EventTourDrawer eventMeta={eventMeta} action={setEventOpen} />
      </Drawer>
    </Grid>
  );
};

EventTour.propTypes = {
  eventMeta: PropTypes.object.isRequired,
};

export default EventTour;
